export namespace Svg {
    export function close(width: number = 30): string {
        return `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width:${width}px; height:auto" viewBox="0 0 102 102" >
    <path class='svg-icon-close' xmlns="http://www.w3.org/2000/svg" d="M81.4,13.6L52.1,42.9c-1.2,1.2-3.1,1.2-4.2,0L18.6,13.6c-1.2-1.2-3.1-1.2-4.2,0l0,0c-1.2,1.2-1.2,3.1,0,4.2l29.3,29.3  c1.2,1.2,1.2,3.1,0,4.2L14.3,80.7c-1.2,1.2-1.2,3.1,0,4.2h0c1.2,1.2,3.1,1.2,4.2,0l29.3-29.3c1.2-1.2,3.1-1.2,4.2,0L81.4,85  c1.2,1.2,3.1,1.2,4.2,0l0,0c1.2-1.2,1.2-3.1,0-4.2L56.4,51.4c-1.2-1.2-1.2-3.1,0-4.2l29.3-29.3c1.2-1.2,1.2-3.1,0-4.2v0  C84.5,12.5,82.6,12.5,81.4,13.6z"/>
  </svg>
  `;
    }

    export function preloaderLogo(width: number = 70): string {
        return `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
            style="width:${width}px; height:auto" viewBox="0 0 80 120">
  
        <style>
            @keyframes move {
                0% {
                    transform: matrix(.3, 0, 0, .55, 0, 0);
                    opacity: 0;
                }
        
                20% {
        
                    opacity: 1;
                }
        
                100% {
                    transform: matrix(1.1, 0, 0, 1.1, 0, -65);
                    opacity: 0;
                }
            }
        
        
            @keyframes move1 {
                0% {
                    opacity: 0.291955
                }
        
                100% {
                    transform: matrix(1.1, 0, 0, 1.1, 0, -65);
                    opacity: 0;
                }
            }
            @keyframes move2 {
                0% {
                    opacity: 0.666955;
                }
        
                100% {
                    transform: matrix(1.1, 0, 0, 1.1, 0, -65);
                    opacity: 0;
                }
            }
        
            @keyframes move3 {
                0% {
                    opacity: 0.832181;
                    transform: matrix(0.433149, 0, 0, 0.64154, 0, -10.8184);
                }
        
                100% {
                    transform: matrix(1.1, 0, 0, 1.1, 0, -65);
                    opacity: 0;
                }
            }
        
            
        
            .svg-wave{
                transform-origin:center center;
                animation-timing-function: linear;
                transform: matrix(0.913149, 0, 0, 0.97154, 0, -49.8184);
                opacity: 0;
                animation:move1 .6s;
            }
        
           
        
            .svg-wave:nth-child(2){
                transform: matrix(0.673149, 0, 0, 0.80654, 0, -30.3184);
                animation:move2 .9s;
            }
        
            .svg-wave:nth-child(3){
                transform: matrix(0.433149, 0, 0, 0.64154, 0, -10.8184);
                animation:move3 1.6s;
            }
            
        
        
        
            
            .svg-icon-logo-body-wave{
                transform-origin:center center;
                opacity: 0;
                animation:move 1s infinite;
                animation-timing-function: linear;
                transform: matrix(.3, 0, 0, .55, 0, 0);
                animation-delay: .3s;
            }
            .svg-icon-logo-body-wave:nth-child(2){
                animation-delay: .6s;
            }
          
            .svg-icon-logo-body-wave:nth-child(3){
                animation-delay: .9s;
            } 
        
        
        </style>
            <path stroke="null" class="svg-wave svg-icon-logo-body" d="m8.35128,98.31001a3.46,3.46 0 1 0 3.11,6.16a61.4,61.4 0 0 1 28.22,-6.76a62.17,62.17 0 0 1 28.78,7.08a3.47,3.47 0 1 0 3.22,-6.14a69.2,69.2 0 0 0 -32,-7.86a68.21,68.21 0 0 0 -31.33,7.52" />
            <path stroke="null" class="svg-wave svg-icon-logo-body" d="m8.35128,98.31001a3.46,3.46 0 1 0 3.11,6.16a61.4,61.4 0 0 1 28.22,-6.76a62.17,62.17 0 0 1 28.78,7.08a3.47,3.47 0 1 0 3.22,-6.14a69.2,69.2 0 0 0 -32,-7.86a68.21,68.21 0 0 0 -31.33,7.52" />
            <path stroke="null" class="svg-wave svg-icon-logo-body" d="m8.35128,98.31001a3.46,3.46 0 1 0 3.11,6.16a61.4,61.4 0 0 1 28.22,-6.76a62.17,62.17 0 0 1 28.78,7.08a3.47,3.47 0 1 0 3.22,-6.14a69.2,69.2 0 0 0 -32,-7.86a68.21,68.21 0 0 0 -31.33,7.52" />
            <g>
                <path stroke="null" class="svg-icon-logo-body svg-icon-logo-body-wave svg-icon-logo-w3" d="m8.35128,98.31001a3.46,3.46 0 1 0 3.11,6.16a61.4,61.4 0 0 1 28.22,-6.76a62.17,62.17 0 0 1 28.78,7.08a3.47,3.47 0 1 0 3.22,-6.14a69.2,69.2 0 0 0 -32,-7.86a68.21,68.21 0 0 0 -31.33,7.52" />
                <path stroke="null" class="svg-icon-logo-body svg-icon-logo-body-wave svg-icon-logo-w2" d="m8.35128,98.31001a3.46,3.46 0 1 0 3.11,6.16a61.4,61.4 0 0 1 28.22,-6.76a62.17,62.17 0 0 1 28.78,7.08a3.47,3.47 0 1 0 3.22,-6.14a69.2,69.2 0 0 0 -32,-7.86a68.21,68.21 0 0 0 -31.33,7.52" />
                <path stroke="null" class="svg-icon-logo-body svg-icon-logo-body-wave svg-icon-logo-w1" d="m8.35128,98.31001a3.46,3.46 0 1 0 3.11,6.16a61.4,61.4 0 0 1 28.22,-6.76a62.17,62.17 0 0 1 28.78,7.08a3.47,3.47 0 1 0 3.22,-6.14a69.2,69.2 0 0 0 -32,-7.86a68.21,68.21 0 0 0 -31.33,7.52"/>
                <g stroke="null" class="svg-icon-logo-bubble-wrap bubble-transform">
                    <path class="svg-icon-logo-body svg-icon-logo-bubble" stroke="null" d="m21.55,101.54999a18.45,18.45 0 1 0 18.45902,-18.45a18.45,18.45 0 0 0 -18.45902,18.45"/>
                    <path class="svg-icon-logo-m" fill="#fff" stroke="null" d="m48.40851,94.30532l0,14.57956s0.10826,0.9022 -0.55936,0.97438a15.54492,15.54492 0 0 1 -2.30963,0a0.75785,0.75785 0 0 1 -0.821,-0.66763c-0.10826,-0.71274 0,-8.87765 0,-8.87765l0,-0.9022l-3.2389,4.15914s-0.821,1.18188 -1.23601,1.23601a1.01046,1.01046 0 0 1 -1.07362,-0.46012c-0.35186,-0.46012 -3.54565,-4.92601 -3.54565,-4.92601l0,9.40995s0.06315,1.05557 -0.76687,1.05557s-2.30963,0 -2.30963,0a0.9022,0.9022 0 0 1 -0.72176,-0.9022c-0.05413,-0.75785 0,-14.73293 0,-14.73293a0.9022,0.9022 0 0 1 0.9022,-0.9022c0.9022,-0.04511 2.21039,0 2.21039,0s0.9022,-0.15337 1.84951,1.44352s3.28401,4.72753 3.28401,4.72753l4.15914,-5.4132a1.70516,1.70516 0 0 1 1.38037,-0.73078l1.98484,0a0.83905,0.83905 0 0 1 0.821,0.9022" />
                </g>
            </g>
          </svg>
            
    `;
    }

    export function logout(width: number = 20): string {
        return `
            <?xml version="1.0" encoding="UTF-8"?>
            <svg style="width:${width}px; height:auto"width="20px" height="19px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">            
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                    <g transform="translate(-1261.000000, -31.000000)" stroke="#FFFFFF" stroke-width="2">
                        <g>
                            <g transform="translate(1262.000000, 32.000000)">
                                <g class="logout-arrow">
                                    <polyline transform="translate(15.733333, 8.200000) rotate(90.000000) translate(-15.733333, -8.200000) " points="11.3333333 10.4 15.7333333 6 20.1333333 10.4"></polyline>
                                    <path d="M17.6666667,8.33333333 L6.97918697,8.33333333"></path>
                                </g>
                                
                                <path d="M12.6666667,4 L12.6666667,11.5964848 C12.6666667,12.2611679 12.1297429,12.8 11.4640662,12.8 L-2.13073285,12.8 C-2.79491076,12.8 -3.33333333,12.2617639 -3.33333333,11.5964848 L-3.33333333,4" transform="translate(4.666667, 8.400000) scale(-1, 1) rotate(-90.000000) translate(-4.666667, -8.400000) "></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        `;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/svg/Svg.ts